import {
  getEffectiveContractSize,
  getEffectiveMinContractIncrement,
  getProduct,
} from '#/products/domain';
import {
  parseFormattedFloat,
  unformatDecimal,
} from '@paradigm/utils/formatDecimal';
import { formatProductQty } from '#/unified-rfqs/ui/decimal-format';
import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';
import { isDatedInstrument } from '#/unified-rfqs/ui/rfqs/legs-functions';

export default function quantityView(
  value: string,
  [firstLeg]: readonly DrfqLeg[],
) {
  const product = getProduct(firstLeg!.product_code);
  const { quantityPrecision } = product;
  const unformattedQty = unformatDecimal(value);

  return {
    value,
    precision: quantityPrecision,
    error: validateQuantityErrors(
      unformattedQty,
      product,
      isDatedInstrument(firstLeg!.instrument_name),
    ),
  };
}

export const validateQuantityErrors = (
  quantity: string,
  product: ReturnType<typeof getProduct>,
  isDated: boolean,
): string | undefined => {
  if (quantity === '') return;
  const minContractIncrement = getEffectiveMinContractIncrement(
    product,
    isDated,
  );

  const formattedNormalizedValue = formatProductQty(quantity, product.code);
  const floatValue = parseFormattedFloat(formattedNormalizedValue);

  const minIncrement =
    minContractIncrement * getEffectiveContractSize(product, isDated);
  if (!Number.isInteger(minIncrement)) return;

  const isValidMinIncrement = floatValue % minIncrement === 0;
  if (isValidMinIncrement) return;

  return `${formattedNormalizedValue} is not a valid increment of ${minIncrement}`;
};
